/* eslint-disable prettier/prettier */
import React from 'react';
import { Checkbox, TextArea } from 'semantic-ui-react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import './SkillsCard.css';

const SkillsCard = ({
  stepInfo,
  handleCheckboxChange,
  skills,
  otherSkills,
  handleOtherOptionsInputChange,
}) => {
  const [card] = stepInfo.cards;
  const isSelectedOtherSkills = includes(skills, 'other');

  return (
    <div className="col">
      <div className="row">
        {card.inner_cards.map(inner => (
          <div key={inner.key} className="col-12 col-md-6 d-flex mb-5">
            <div className="bg-white shadow-card p-5 align-self-stretch w-100">
              <div className="row">
                <div className="col-12 col-lg text-center">
                  <div className={`skills-card-container-header--${inner.key}`} />
                  <p className="skills-card-container-header-title">{inner.name}</p>
                  <p className="skills-card-container-header-description">
                    {inner.description}
                  </p>
                </div>
                <div className="col-12 col-lg mt-3 mt-lg-0">
                  <p className="skills-card-container-inputs-title">
                    {inner.inputHeader}:
                  </p>
                  <ul className="skills-card-container-inputs-list">
                    {inner.checkboxes.map(check => (
                      <li
                        key={check.value}
                        className={`skills-card-container-inputs-item ${check.icon &&
                          'skills-card-container-inputs-item-icon'}`}
                      >
                        <Checkbox
                          className="skills-card-checkbox"
                          label={check.description}
                          value={check.value}
                          onChange={handleCheckboxChange}
                          checked={includes(skills, check.value)}
                        />
                        {check.icon && (
                          <div
                            className={`skills-card-container-inputs-item--${
                              check.value
                            }`}
                          />
                        )}
                      </li>
                    ))}

                    {inner.other &&
                      isSelectedOtherSkills && (
                      <div className="skills-card-container-inputs-other">
                        <TextArea
                          className="skills-card-container-inputs-textarea"
                          defaultValue={otherSkills}
                          onChange={e => handleOtherOptionsInputChange(e)}
                          name="otherSkills"
                          rows="2"
                          cols="26"/>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

SkillsCard.propTypes = {
  skills: PropTypes.array.isRequired,
  otherSkills: PropTypes.string,
  stepInfo: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  handleOtherOptionsInputChange: PropTypes.func.isRequired,
};

export default SkillsCard;



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolio/SkillsCard/SkillsCard.js